import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { PAGE_TEXT } from '../../../constants/system-pages.constants';
import { clearSystemPageAccess } from '../../../../guard/navigation-flag.guard';

@Component({
  selector: 'app-landing-page',
  imports: [],
  templateUrl: './landing-page.html',
  styleUrl: './landing-page.scss',
})
export class LandingPage implements OnInit, OnDestroy {
  private authService = inject(MsalService);
  protected readonly text = PAGE_TEXT.landing;

  constructor(private router: Router) {}

  ngOnInit(): void {
    const activeAccount =
      this.authService.instance.getActiveAccount() ?? this.authService.instance.getAllAccounts()[0];

    if (activeAccount) {
      this.router.navigate(['/workspace']);
    }
  }

  onSignIn(): void {
    this.router.navigate(['/workspace']);
  }

  ngOnDestroy(): void {
    clearSystemPageAccess();
  }
}